import { unwrapResult } from '@reduxjs/toolkit';
import * as React from 'react';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import {
    Alert, Button, Card, CardBody, CardTitle, Col, FormFeedback, Input, Nav,
    NavItem, NavLink, Row, TabContent, Table, TabPane, Toast, ToastBody, ToastHeader
} from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../hooks/index';
import {
    AfrAssignmentRequest, AfrReview, postAssignment, postComment,
    PostCommentRequest, selectReviews
} from '../redux/AfrReviewSlice';
import { Afr, getSelectedAfr } from '../redux/AfrSlice';
import { getAllActiveAdmins } from '../redux/ContactSlice';
import dateHelper from '../utils/dateHelper';
import enums from '../utils/enums';
import DiscrepancyEmail from './feature/DiscrepancyEmail';
import utilityHelper from '../utils/utilityHelper';
import { AdminUserRoleEnum } from '../redux/UserSlice';
import CanShowGivenAdminUserRole from './feature/CanShowGivenAdminUserRole';




const AFRAssignmentDetail = () => {
    const dispatch = useAppDispatch();

    interface DropdownOption {
        label: string;
        value: string;
    }

    const emptyDropdownList: Array<DropdownOption> = [];

    const data: Array<AfrReview> = useAppSelector(selectReviews);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);

    const [activeTab, setActiveTab] = useState("1");
    const [selectedContact, setSelectedContact] = useState("");
    const [comment, setComment] = useState("");
    const [contactList, setContactList] = useState (emptyDropdownList);
    const [currentReview, setCurrentReview] = useState<AfrReview | null>(null);
    const [enableValidation, setEnableValidation] = useState(false);
    var review: AfrReview | null = null;
    const firstOption = { label: "Select One", value: "---" };

    if (currentAfr) {
        if (data && data.length > 0) {
            review = data.filter(x => {
                return x.connector.includes(currentAfr.afrId);
//                return x.connector.includes(currentAfr.afrId.split("_")[0] + "," + currentAfr.year)
            })[0];
        }
    }

    
    const toggle = (tab: any) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }

    const contactsHandleChange = function (event: any) {
        setSelectedContact(event.value);
        setEnableValidation(false);
    }


    const handleEventClick = function (event : any) {
    /* here go the dispatchers */
        var curConnector = "";
        if(currentReview !== null && currentReview.connector !== null) {

            curConnector = currentReview.connector;
        }
        var action: string = event.target.name;
        switch (action) {
            case "save-contact":
                setEnableValidation(true);
                // update Review Object in Redux
                var req: AfrAssignmentRequest = {
                    assigneeId: selectedContact,
                    afrVersionId: curConnector
                };
                dispatch(postAssignment(req));
                setSelectedContact(firstOption.value);
                break;
            case "save-comment":
                // update Review Object in Redux
                var commentReq: PostCommentRequest = {
                    comment: comment,
                    afrVersionId: curConnector,
                    role: enums.commentType.review,
                };
                dispatch(postComment(commentReq));
                setComment("");
                break;
        }
    }

    const getHeaderValue = () => {
        var result: string = "";
        if (currentReview && currentAfr) {
            var parts: string[] = currentReview.connector.split(",");
            // This is the base descriptor
            result = parts[0] + " - "
                + currentReview.entityName
                + ", Report Type: "
            if (parts.length < 4) {
                // This is the old AFR model
                result += "AFR, Fiscal Year: " + currentReview.afrYear.toString();
            } else {
                // This is the non-AFR model
                result += utilityHelper.taxonomyTitleFromConnector(parts[2]) + ", Fiscal Year: " + currentReview.afrYear.toString();
                if (currentAfr.logicalPeriod && currentAfr.logicalPeriod !== "ANNUAL") {
                    result += " - " + currentAfr.logicalPeriod.replace("Q_","Quarter ");
                }
            }
        }
        return result;
    };

    const contacts = (< div >
        <Select
            value={contactList &&
                contactList.filter(function (option) {
                    return option.value === selectedContact;
                })
            }
            name="CONTACTS"
            onChange={contactsHandleChange}
            options={contactList}
        />

    </div >);

    const generateAssignedHistory = function () {

        if ( !(currentReview && currentReview.assignments && currentReview.assignments.length > 0 ) ) {
            return (<div><Alert color="danger"><p>There are no assignment history for the chosen entity in the selected year!</p></Alert></div>)
        }

        var reviewAssignatedList = [...currentReview.assignments];
        reviewAssignatedList.sort((a, b) => (a.timestamp < b.timestamp) ? 1 : ((b.timestamp < a.timestamp) ? -1 : 0));
        
        return (
            <React.Fragment>
                <Toast className="auditDetail">
                    <ToastHeader className="auditDetail">Assignment History</ToastHeader>
                    <ToastBody>
                        <div className="scrollable-table">
                            <Table className="table" >
                                <thead className="scrollable-table-header thead-dark">
                                    <tr>
                                        <th className="col-1">User</th>
                                        <th className="col-1">Assigned Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {reviewAssignatedList && reviewAssignatedList.map((option, idx) => (
                                        <tr>
                                            <td>{option.assignee && option.assignee.lastName}</td>
                                            <td>{dateHelper.stringDateInFormat(option.timestamp, "LL/dd/yyyy")}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                        </div>
                        </ToastBody>
                </Toast>
            </React.Fragment>
            );
          
    }


    const generateCommentHistory = function () {

        if (!(currentReview && currentReview.comments && currentReview.comments.length > 0)) {
            return (<div><Alert color="danger"><p>There are no comments history for the chosen entity in the selected year!</p></Alert></div>)
        }

        var reviewCommentList = [...currentReview.comments];
        reviewCommentList.sort((a, b) => (a.timestamp < b.timestamp) ? 1 : ((b.timestamp < a.timestamp) ? -1 : 0));

        return (
            <React.Fragment>
                <Toast className="auditDetail">
                    <ToastHeader className="auditDetail">Comments history</ToastHeader>
                    <ToastBody>
                        <div className="scrollable-table">
                            <Table className="table" >
                                <thead className="scrollable-table-header thead-dark">
                                    <tr>
                                        <th className="col-1">Comment</th>
                                        <th className="col-1">Created Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {reviewCommentList && reviewCommentList.map((option, idx) => (
                                        <tr>
                                            <td>{option.comment}</td>
                                            <td>{dateHelper.stringDateInFormat(option.timestamp, "LL/dd/yyyy")}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                        </div>
                    </ToastBody>
                </Toast>
            </React.Fragment>
        );

    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "save-contact":
                if (selectedContact === "" || selectedContact === "---") {
                    result = false;
                }
                break;
            case "save-comment":
                if (comment.length === 0) {
                    result = false;
                }
                break;
        }
        return result;
    }

    /* *****************************************************************************
     * Events and Effects
     *******************************************************************************/
    async function getContactList() {
        const resultAction = await dispatch(getAllActiveAdmins())
        const originalPromiseResult = unwrapResult(resultAction);
        originalPromiseResult.unshift(firstOption);
        setContactList(originalPromiseResult);
    }

    useEffect(function () {
        setCurrentReview(null);
        if (currentAfr) {
            setCurrentReview(data.filter(x => x.connector.includes(currentAfr.afrId.split("^")[0] + "," + currentAfr.year))[0]);
        }

    }, [currentAfr]);


    useEffect(function () {
        setCurrentReview(review);
    }, [review])

    useEffect(function () {

        getContactList();

    }, []);

    useEffect(function () {

        var selected: string = "";
        setEnableValidation(false);
        setSelectedContact(firstOption.value);

    }, [currentReview]);


    /*******************************************************************************/
    return (
        <React.Fragment>
            { currentReview && (
                <div>
                    <Toast className="">
                        <ToastHeader className="" style={{ color: "#4287d1", backgroundColor: "#DAE7F5" }}>
                            { getHeaderValue() }
                        </ToastHeader>
                        <ToastBody className="">
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('1')}
                                            onClick={() => { toggle('1'); }}
                                        >
                                            Assignment
                                    </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('2')}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            Discrepancy
                                    </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('3')}
                                            onClick={() => { toggle('3'); }}
                                        >
                                            Comments
                                    </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <CanShowGivenAdminUserRole
                                                permittedRoles={[
                                                    AdminUserRoleEnum.UserManager
                                                ]}>
                                                {currentReview && currentReview.readyForReview === enums.assigmentStatus.ready &&
                                                    (
                                                        <Col sm="6">
                                                            <Card body>
                                                                <CardTitle><h4>Assign Contact</h4></CardTitle>
                                                                <CardBody>
                                                                    {contacts}
                                                                    {(!isValid("save-contact")) && enableValidation &&
                                                                        (<div><Alert color="danger"><p>Please select a reviewer from the list!</p></Alert></div>)
                                                                    }
                                                                </CardBody>
                                                                <Row>
                                                                    <Col className="text-md-right">
                                                                        <Button type="button" name="save-contact" disabled={(selectedContact === firstOption.value)} onClick={handleEventClick}>Save</Button>{"  "}
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        </Col>
                                                    )}
                                            </CanShowGivenAdminUserRole>
                                           
                                            <Col sm="6">
                                                {generateAssignedHistory()}
                                            </Col>

                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <DiscrepancyEmail allowEdit={false}/>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col sm="6">
                                                <Card body>
                                                    <CardTitle><h4>Comment</h4></CardTitle>
                                                    <CardBody>
                                                        <Input type="textarea" value={comment} disabled={false} rows="10"
                                                            onChange={(e) => setComment(e.currentTarget.value)}
                                                            valid={isValid("save-comment")}
                                                            invalid={!isValid("save-comment")} />
                                                        <FormFeedback>Comment is required.</FormFeedback>

                                                    </CardBody>
                                                    <Row>
                                                        <Col className="text-md-right">
                                                            <Button type="button" name="save-comment" disabled={(comment.length === 0)} onClick={handleEventClick}>Save</Button>{"  "}
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col sm="6">
                                                {generateCommentHistory()}
                                            </Col>

                                        </Row>

                                    </TabPane>
                                </TabContent>
                            </div>


                        </ToastBody>
                    </Toast>


                </div>
            )}
        </React.Fragment>
    );
};

export default AFRAssignmentDetail;